<script setup lang="ts"></script>

<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shape-rendering="crispEdges">
    <path
      d="M5 12H19"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>
